import React from 'react';
import { Link } from 'react-router-dom';
import { partnerFirms } from '../data/siteContent';

export default function ForAdvisors() {
  return (
    <div className="bg-white min-h-screen py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-8">
        <header className="space-y-3 text-center">
          <p className="text-xs uppercase tracking-[0.6em] text-gray-500">Advisor portal</p>
          <h1 className="text-4xl font-bold text-charcoal">Advisor referrals & partner enablement</h1>
          <p className="text-gray-600">
            We keep advisors in the loop through co-branded microsites, automated partner reporting, and quarterly learnings from the Lyon Share podcast.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-3">
          {partnerFirms.map((partner) => (
            <article key={partner.name} className="rounded-2xl border border-gray-200 bg-gray-warm p-5">
              <p className="text-xs uppercase tracking-[0.4em] text-gray-500">Partner story</p>
              <h2 className="text-lg font-semibold text-charcoal">{partner.name}</h2>
              <p className="text-gray-600 text-sm mt-2">{partner.description}</p>
            </article>
          ))}
        </div>

        <section className="rounded-3xl border border-primary/40 bg-primary/5 p-8 shadow-lg">
          <p className="text-sm uppercase tracking-[0.4em] text-primary">What partners get</p>
          <ul className="mt-4 space-y-3 text-gray-600">
            <li>Shared analytics dashboard with referral updates</li>
            <li>Co-branded educational content and webinars</li>
            <li>White-label advisories and concierge intake</li>
          </ul>
          <div className="mt-6 text-sm font-semibold text-primary">
            <Link to="/contact">Introduce a client →</Link>
          </div>
        </section>
      </div>
    </div>
  );
}
